import _CollapsableSidebarRoot from './_internal/components/CollapsableSidebarRoot';
export const CollapsableSidebarRoot = _CollapsableSidebarRoot;
export * from './_internal/constants/SidebarConstants';